<template>
  <div class="row" justify="center">
    <v-col md="12">
      <v-breadcrumbs :items="items">
        <template v-slot:divider>
          <v-icon>mdi-forward</v-icon>
        </template>
      </v-breadcrumbs>
    </v-col>
    <v-col>
      <SummaryTable :rating-list="ratingsSummary" type="learner" />
    </v-col>
  </div>
</template>

<script>
import SummaryTable from "@/components/Feedback/SummaryTable.vue";
import { mapActions, mapGetters } from "vuex";
import {
  GET_LEARNER_FEEDBACK_SUMMARY,
  M_OU,
  LOAD_LEARNER_FEEDBACK_SUMMARY,
} from "@/store/mutation-list";
export default {
  name: "ViewLearnerFeedback",
  components: { SummaryTable },
  data() {
    return {
      items: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/dashboard/home",
        },
        {
          text: "View Learner Feedbacks",
          disabled: true,
          href: "/dashboard/viewlearnerfeedback",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      ratingsSummary: `${M_OU}${GET_LEARNER_FEEDBACK_SUMMARY}`,
    }),
  },
  methods: {
    ...mapActions({
      loadLearnerFBs: `${M_OU}${LOAD_LEARNER_FEEDBACK_SUMMARY}`,
    }),
  },
  created() {
    this.loadLearnerFBs();
  },
};
</script>

<style></style>
